import { SlugNameService } from './../../Services/slug-name.service';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

import { Subscription } from "rxjs";
import { AccountSettingService } from "src/app/Services/account-setting.service";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { HomePageService } from "src/app/Services/home-page.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { ReactivityService } from "src/app/Services/reactivity.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

import { CheckoutService } from "../../Services/checkout.service";
import { ProductsService } from "../../Services/product.service";

@Component({
    selector: "embryo-NewProductsCard",
    templateUrl: "./NewProductsCard.component.html",
    styleUrls: ["./NewProductsCard.component.scss"],
})
export class NewProductsCardComponent implements OnInit, OnDestroy, OnChanges {
    varinaceLength: any;
    lang: any;
    user: any;
    ChoosenOptionalImage: any;
    showMainImage: boolean = false;
    variant: any;
    optionArray = [];
    @Input() homePageDataSectionsSilders: any;
    sliderDataTest: any;
    @Input() product: any;
    @Input() currency: string = "";
    @Output() addToCart: EventEmitter<any> = new EventEmitter();
    editName: any;
    subscription: Subscription;
    subscription2: Subscription;
    cartProducts: Array<any> = [];
    toggleLoading: boolean = false;
    toggleCartLoading: boolean = false;
    toggleCompareLoading: boolean = false;
    environmentVariables: any;
    redirectToProduct: boolean = false;
    @Input() variantsLimit: number = 4;
    variantValues: any[] = [];
    variantOptions: any = [];
    productImageBackup: any = {};
    compareListProducts = [];
    constructor(
        public embryoService: EmbryoService,
        public snackBar: MatSnackBar,
        public HomeService: HomePageService,
        public productService: ProductsService,
        public checkoutService: CheckoutService,
        public userLoginServies: LoginUsersService,
        private reactivityService: ReactivityService,
        private router: Router,
        private account: AccountSettingService,
        private confgServ: StaticPagesService,
        private marketingService: MarketingService,
				private slugNameService:SlugNameService,
    ) {
        this.getInitilizingData();
        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
        });

        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                if (data && data.favouriteProduct) {
                    if (
                        this.product &&
                        this.product.id === data.favouriteProduct.id
                    ) {
                        this.product.is_favourite = true;
                        this.product.favouriteLoading = false;
                    }
                } else if (data && data.unFavouriteProduct) {
                    if (
                        this.product &&
                        this.product.id === data.unFavouriteProduct.id
                    ) {
                        this.product.is_favourite = false;
                        this.product.favouriteLoading = false;
                    }
                }
            }
        );
        this.subscription2 = this.embryoService.unCompareProductSub.subscribe(
            (product: any) => {
                if (product && this.product && this.product.id === product.id) {
                    this.product.is_compare = false;
                }
            }
        );
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.redirectToProduct =
                this.environmentVariables?.PRODUCT_TYPE == "main";
        });
    }
    ngOnInit() {
        // if (this.product) {
        //     this.embryoService.compareListSub.subscribe((res) => {
        //         this.compareListProducts = res;
        //         var pro = this.product;
        //         const found = this.compareListProducts.some(
        //             (el: any) =>
        //                 el.id == (pro?.id || pro?.product_variants[0].id)
        //         );
        //         if (found) {
        //             if (this.environmentVariables?.PRODUCT_TYPE == "main") {
        //                 this.product.product_variants[0].is_compare = true;
        //             } else {
        //                 this.product.is_compare = true;
        //             }
        //         } else {
        //             this.product.is_compare = false;
        //         }
        //     });
        // }
        this.embryoService.productCartSub.subscribe((res) => {
            this.cartProducts = res;
            if (this.cartProducts.length) {
            }
        });

        this.embryoService.favouritesListSub.subscribe((data) => {
            if (data) {
                let ind = data.findIndex((i: any) => i.id == this.product.id);
                this.product.is_favourite = ind !== -1;
                this.product.favouriteLoading = false;
            }
        });

        this.embryoService.compareListSub.subscribe((data) => {
            if (data) {
                let ind = data.findIndex((i: any) => i.id == this.product.id);
                this.product.is_compare = ind !== -1;
                this.product.toggleCompareLoading = false;
            }
        });

        this.editName = this.product.name.replace(/\s/g, "-");

        this.lang = localStorage.getItem("lang");
        let wishlist_items =
            JSON.parse(<string>localStorage.getItem("wishListItems")) || [];
        this.showMainImage = true;

        if (this.userLoginServies.isGuest()) {
            let ind = wishlist_items.findIndex(
                (wi: any) => wi.id == this.product.id
            );
            if (ind !== -1) {
                this.product.is_favourite = true;
            }
        }

        if (
            this.product &&
            this.product.product_variants &&
            this.product.product_variants.length
        ) {
            this.product.available_value_color = [];
            this.product.product_variants.forEach((product_variant: any) => {
                product_variant.options.forEach((option: any) => {
                    if (option.option.type == "4") {
                        option.values.find((value: any) => {
                            this.product.available_value_color.push(value);
                            this.product.available_value_color =
                                this.product.available_value_color.filter(
                                    (color: any, index: number, color2: any) =>
                                        index ===
                                        color2.findIndex(
                                            (t: any) => t.id === color.id
                                        )
                                );
                        });
                    }
                });
            });
        }

        if (
            this.userLoginServies.isGuest() &&
            localStorage.getItem("compareItems")
        ) {
            let index = JSON.parse(
                <string>localStorage.getItem("compareItems")
            ).findIndex((item: any) => item.id == this.product.id);
            this.product.is_compare = index !== -1;
        }
        this.productImageBackup = this.product?.image;
        this.user = this.userLoginServies.getUser();
    }

    ngOnChanges() {
        if (this.product) {
            this.product["slug_name"] = this.getProductName(this.product);
        }
        if (
            this.product != null &&
            this.product != undefined &&
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_TYPE == "main" &&
            this.product.product_variants_options &&
            this.product.product_variants_options.length > 0
        ) {
            if (this.product.product_variants_options[0].values) {
                this.variantOptions =
                    this.product.product_variants_options[0].option;
                this.variantValues =
                    this.product.product_variants_options[0].values;
            }
        } else {
            this.variantValues.push({ image: this.product.image });
        }
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
        if (this.subscription2) this.subscription2.unsubscribe();
    }

    switchMainImage(image: any) {
        this.product.image = image?.image;
    }

    originalImage(): void {
        this.product.image = this.productImageBackup;
    }

    checkAmount() {
        const cartIds = this.cartProducts.map((item) => item.id);
        if (cartIds.includes(this.product.id)) {
            const cartProduct = this.cartProducts.find(
                (item) => item.id === this.product.id
            );
            this.product.amount = cartProduct.amount;
        }
    }

    addToFavouriteList(product: any, productType: string) {
        if (!product) {
            product = this.product;
        }
        product.favouriteLoading = true;
        if (!product.is_favourite) {
            this.reactivityService.setDataToStore("currentFavProduct", product);
            this.marketingService.cartEvents("add_to_wishlist", product);
        } else {
            this.reactivityService.setDataToStore(
                "currentUnFavouriteProduct",
                product
            );
        }
        if (productType == "main") {
            product.is_favourite = !product.is_favourite;
        }
    }

    addToCompareList(product: any) {
        product.toggleCompareLoading = true;
        !product.is_compare
            ? this.reactivityService.setDataToStore(
                  "addProductToCompare",
                  product
              )
            : this.reactivityService.setDataToStore(
                  "removeProductFromCompare",
                  product
              );
        if (this.environmentVariables?.PRODUCT_TYPE == "main") {
            product.is_compare = !product.is_compare;
        }
    }

    setImage(img: any) {
        this.ChoosenOptionalImage = img;
    }

    checkFavorite() {}

    setChossenData(id: any) {
        // this.product = this.filterVariantByValue(id);
        // this.showMainImage = false;
        // this.product.name = this.product.name;
        // this.ChoosenOptionalImage = this.product.image;
        let variant = this.filterVariantByValue(id);
        this.switchMainImage(variant);
    }

    filterVariantByValue(id: any) {
        for (let i = 0; i < this.product?.product_variants?.length; i++) {
            for (
                let y = 0;
                y < this.product?.product_variants[i]?.options.length;
                y++
            ) {
                for (
                    let x = 0;
                    x <
                    this.product?.product_variants[i]?.options[y]?.values
                        .length;
                    x++
                ) {
                    if (
                        this.product?.product_variants[i]?.options[y]?.values[x]
                            ?.id === id
                    ) {
                        return this.product?.product_variants[i];
                    }
                }
            }
        }
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }
}
